import React, { useEffect, useState } from 'react';
import { Button, Table } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import Heading from '../../components/Heading';
import DragAndDrop from '../../components/DragAndDrop';
import TableHeading from './components/TableHeading';
import TableItem from './components/TableItem';
import Pagination from '../../components/Pagination';

import user from '../../store/user';
import uploadBackgroundProcess from '../../services/uploadBackgroundProcess';
import getBackgroundProcesses from '../../services/getBackgroundProcesses';

import './styles.scss';
import Loader from '../../components/Loader';
import ButtonContainer from '../../components/ButtonContainer';
import Dropdown from '../../components/Dropdown/Dropdown';
import ResponseModal from './components/ResponseModal';

const PAGE_CONTENT = 10; // Number of items per page

const STATUS = {
    notSelected: 'Please select a CSV file to be uploaded',
    uploading: 'CSV file is being uploaded... Please wait',
    uploadSuccess: 'CSV file uploaded successfully and recruiters are now being registered in the background, please keep refreshing the list to see the newly registered recruiters',
    uploadError: 'Error while uploading CSV file',
}

const TABS = [
    { name: 'All', id: '0,1,2,3' },
    { name: 'Pending', id: '0' },
    { name: 'Processing', id: '1' },  
    { name: 'Failed', id: '2' },
    { name: 'Success', id: '3' },
];

const AutoRecruiterRegistration = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [adminId, setAdminId] = useState(null);
    const [processes, setProcesses] = useState([]);
    const [totalProcesses, setTotalProcesses] = useState(0);
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState(STATUS.notSelected);
    const [tab, setTab] = useState(TABS[0].id);
    const [showResponseModal, setShowResponseModal] = useState(false);
    const [selectedCsvResponse, setSelectedCsvResponse] = useState();

    const onUpload = async (file) => {
        if (!adminId) return toast.error('Admin ID is not set. Please try again later.');
        setStatus(STATUS.uploading);
        try {
            const formData = new FormData();
            formData.append('csv', file);
            const response = await uploadBackgroundProcess(adminId, formData, { type: 'recruiter-registration' });
            if (response.status === 200) {
                setStatus(STATUS.uploadSuccess);
                setTab(TABS[1].id);
                fetchList(TABS[1].id);
            }
        } catch (error) {
            setStatus(STATUS.uploadError);
            setSelectedFile(null);
        }
    }

    const onError = (msg) => {
        toast.error(msg);
    }

    const handleSelectedFile = (file) => {
        setSelectedFile(file);
    }

    const handlePageChange = (page) => {
        setLoading(true);
        try {
            const params = {
                pageNumber: page,
                pageContent: PAGE_CONTENT,
                status: tab,
            };
            getBackgroundProcesses(adminId, params).then((response) => {
                if (response.status === 'success') {
                    setProcesses(response.data.list);
                    setTotalProcesses(response.data.count);
                    setPageNumber(page);
                    setLoading(false);
                } else {
                    toast.error('Failed to fetch processes');
                }
            })
        } catch (error) {
            setLoading(false);
        }

    };

    const refreshList = () => fetchList(tab);

    const fetchList = (tabId) => {
        setLoading(true);
        try {
            const params = {
                pageNumber: 1,
                pageContent: PAGE_CONTENT,
                status: tabId || TABS[0].id,
            };
            getBackgroundProcesses(adminId, params).then((response) => {
                if (response.status === 'success') {
                    setProcesses(response.data.list);
                    setPageNumber(1);
                    setTotalProcesses(response.data.count);
                    setLoading(false);
                } else {
                    toast.error('Failed to fetch processes');
                }
            });
        } catch (error) {
            setLoading(false);
        }
    }

    const onTabChange = (e) => {
        setTab(e.target.value);
        fetchList(e.target.value);
    }

    const handleResponseClick = (data) => {
        setSelectedCsvResponse(JSON.parse(data));
        setShowResponseModal(true);
    }

    useEffect(() => {
        async function getProfile() {
            const profile = await user.getProfile();

            return profile;
        }

        getProfile().then(data => {
            setAdminId(data.id);
        })
    }, []);

    useEffect(() => {
        if (adminId) {
            fetchList();
        }
    }, [adminId]);
  return (
      <div>
          <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnVisibilityChange
        draggable={false}
        pauseOnHover
      />
          <div className="page-heading">
              <Heading text="Auto Recruiter Registration" />
          </div>
          <div className='upload-status'>UPLOAD STATUS: <b>{status}</b></div>
          {!adminId ? <Loader /> : <>       
              <div className='file-upload-container'>
                  <DragAndDrop
                    formats={['csv']}
                    onError={onError}
                    onUpload={onUpload}
                    selectedFile={selectedFile}
                    setSelectedFile={handleSelectedFile}
                    />
              </div>
              <ButtonContainer heading='Filter Status: '>
                  <li key='jobPostingDate'> 
                      <Dropdown data={TABS} dropdownChange={onTabChange} defaultValue={tab} />    
                  </li>
              </ButtonContainer>
              <div className='row text-center pagination-bottom'>
                  <Pagination totalItemsCount={totalProcesses} content={PAGE_CONTENT} pageNumber={pageNumber} handlePageChange={handlePageChange} />
                  <Button onClick={refreshList}>Refresh</Button>
              </div>
              {loading ? <Loader /> : 
              <Table
                    fixed
                    selectable
                    className="registration-table"
                    >
                  <TableHeading />
                  {processes.length == 0 ? 
                      <div className='no-records'>
                          No Records
                      </div>
                       : 
                      <>
                          {processes.map((item, index) => (
                              <TableItem key={item.id} data={item} onResponseClick={handleResponseClick} />
                        ))}
                      </>
                }
                  
              </Table>
              }
          </>
          }
          <div className='row text-center pagination-bottom'>
              <Pagination totalItemsCount={totalProcesses} content={PAGE_CONTENT} pageNumber={pageNumber} handlePageChange={handlePageChange} />
          </div>
          {selectedCsvResponse && <ResponseModal show={showResponseModal} onClose={() => setShowResponseModal(false)} data={selectedCsvResponse} />}
      </div>
  );
};

export default AutoRecruiterRegistration;
